import { AlpineComponent } from "alpinejs";
import { GoogleService } from "../api";

type OrderConfirmationPageComponent = AlpineComponent<object>;

export default (orderId: string): OrderConfirmationPageComponent => {
	return {
		async init() {
			const purchase = await GoogleService.purchase({ query: { orderId: orderId } });
			window.dataLayer.push({
				ecommerce: null,
			});
			window.dataLayer.push({
				event: "purchase",
				ecommerce: purchase.data,
			});
		},
	};
};
